/* BPO */
import * as backOfficeStore from './store'

export function backOfficeModule({ store }) {
  store.registerModule('back-office', { ...backOfficeStore, namespaced: true })
}
